namespace GeniuzPOS.Purchase {
    export namespace PoInvoiceReceiveAppService {
        export const baseUrl = 'Purchase/PoInvoiceReceiveApp';

        export declare function Create(request: Serenity.SaveRequest<PoInvoiceReceiveAppRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PoInvoiceReceiveAppRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoInvoiceReceiveAppRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoInvoiceReceiveAppRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetNextNumber(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PoInvoiceReceiveApp/Create",
            Update = "Purchase/PoInvoiceReceiveApp/Update",
            Delete = "Purchase/PoInvoiceReceiveApp/Delete",
            Retrieve = "Purchase/PoInvoiceReceiveApp/Retrieve",
            List = "Purchase/PoInvoiceReceiveApp/List",
            GetNextNumber = "Purchase/PoInvoiceReceiveApp/GetNextNumber"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetNextNumber'
        ].forEach(x => {
            (<any>PoInvoiceReceiveAppService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
